import { InvestPaymentMethodTypes, PaymentPageType } from '../../types/mf-execution.types'

export const autoPayIcon = `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_38073_14104)">
<path d="M11.9775 14.8753C13.6688 12.2335 16.6293 10.4824 19.9987 10.4824C25.255 10.4824 29.516 14.7437 29.516 20.0003" stroke="#1470CC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M28.0199 25.125C26.3286 27.7669 23.3682 29.5179 19.9987 29.5179C14.7425 29.5179 10.4814 25.2566 10.4814 20" stroke="#1470CC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M11.9453 11.2148V14.8756H15.606" stroke="#1470CC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M28.0523 28.7857V25.125H24.3916" stroke="#1470CC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20.0588 18.363L19.3659 20.316H20.7518L20.0588 18.363ZM16.999 22.8L19.3839 16.5H20.7248L23.1097 22.8H21.6427L21.1838 21.504H18.9339L18.4749 22.8H16.999Z" fill="#1470CC"/>
</g>
<defs>
<clipPath id="clip0_38073_14104">
<rect width="21.9987" height="22" fill="white" transform="translate(8.99902 9)"/>
</clipPath>
</defs>
</svg>
`

export const netBankingIcon = `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_38073_13375)">
<path d="M19.9993 29.5181C25.2559 29.5181 29.5172 25.2569 29.5172 20.0003C29.5172 14.7437 25.2559 10.4824 19.9993 10.4824C14.7427 10.4824 10.4814 14.7437 10.4814 20.0003C10.4814 25.2569 14.7427 29.5181 19.9993 29.5181Z" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.4814 20H29.5172" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M23.6603 20.0003C23.4805 23.4809 22.1985 26.814 19.9996 29.5181C17.8007 26.814 16.5187 23.4809 16.3389 20.0003C16.5187 16.5197 17.8007 13.1864 19.9996 10.4824C22.1985 13.1864 23.4805 16.5197 23.6603 20.0003Z" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_38073_13375">
<rect width="22" height="22" fill="white" transform="translate(8.99902 9)"/>
</clipPath>
</defs>
</svg>
`

export const upiIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
  <path d="M29.8152 27.2493H27.8347L30.5891 16H32.5697L29.8152 27.2493Z" fill="#232323"/>
  <path d="M28.7868 16.3552C28.6494 16.1412 28.4377 16.0332 28.15 16.0332H17.2593L16.7198 18.2364L26.6273 18.2352L26.0507 20.5897H18.1247L18.1254 20.5848H16.1446L14.5005 27.2965H16.4824L17.5857 22.7917H26.4951C26.7734 22.7917 27.0353 22.6844 27.2816 22.4697C27.5274 22.2549 27.6891 21.9899 27.7667 21.6735L28.8699 17.1678C28.9504 16.8408 28.9225 16.5695 28.7868 16.3552Z" fill="#232323"/>
  <path d="M13.3467 26.5464C13.2373 26.9919 12.8787 27.3 12.4698 27.3H2.2513C1.97286 27.3 1.7659 27.1927 1.62981 26.9783C1.49383 26.7636 1.46466 26.4981 1.54241 26.1819L4.03574 16.0322H6.01811L3.79109 25.0974H11.7208L13.9478 16.0322H15.9297L13.3467 26.5464Z" fill="#232323"/>
  <path d="M35.9903 16.0204L38.4978 21.6597L33.2266 27.2974L35.9903 16.0204Z" fill="#27803B"/>
  <path d="M34.2326 16.0204L36.7383 21.6597L31.465 27.2974L34.2326 16.0204Z" fill="#E9661C"/>
</svg>`

export const paymentPageConfig: Record<PaymentPageType, { placeholder: string; errorHelpText: string }> = {
  [PaymentPageType.BUY]: {
    placeholder: 'invest',
    errorHelpText: 'investment amount'
  },
  [PaymentPageType.SIP]: {
    placeholder: 'invest',
    errorHelpText: 'SIP amount'
  },
  [PaymentPageType.WITHDRAW]: {
    placeholder: 'withdraw',
    errorHelpText: 'withdrawal amount'
  },
  [PaymentPageType.SWP]: {
    placeholder: 'swp',
    errorHelpText: 'SWP amount'
  },
  [PaymentPageType.TRANSFER]: {
    placeholder: 'transfer',
    errorHelpText: 'transfer amount'
  }
}

export const investPaymentMethodConfig: Record<InvestPaymentMethodTypes, { icon: string; label: string }> = {
  [InvestPaymentMethodTypes.MANDATE]: {
    icon: autoPayIcon,
    label: 'Pay via Autopay'
  },
  [InvestPaymentMethodTypes.NET_BANKING]: {
    icon: netBankingIcon,
    label: 'Net banking'
  },
  [InvestPaymentMethodTypes.UPI]: {
    icon: upiIcon,
    label: 'Pay with UPI'
  },
  [InvestPaymentMethodTypes.UPI_INTENT]: {
    icon: upiIcon,
    label: 'Pay with UPI'
  }
}
